var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotAvailableUser = function SvgNotAvailableUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 279 279"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M-580-317H860V707H-580z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.625)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 127.875,
    cy: 127.875,
    r: 127.875,
    fill: "#D0D7DE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E7780",
    fillRule: "nonzero",
    d: "M127.875 139.5c38.659 0 71.07 28.252 75.541 65.383a2.9 2.9 0 0 1-1.123 2.659c-21.094 16.08-47.065 24.958-74.418 24.958-27.35 0-53.32-8.877-74.415-24.953a2.9 2.9 0 0 1-1.124-2.659c4.468-37.134 36.878-65.388 75.539-65.388m69.387 63.365c-5.331-32.846-34.6-57.553-69.387-57.553-35.163 0-64.686 25.243-69.549 58.62 19.843 14.672 44.058 22.756 69.549 22.756 24.914 0 48.608-7.722 68.191-21.77l1.36-.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.875,
    cy: 235.406,
    r: 40.688,
    fill: "#F3F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E7780",
    fillRule: "nonzero",
    d: "M143.595 194.734a43.5 43.5 0 0 0-15.72-2.922c-24.076 0-43.594 19.518-43.594 43.594S103.8 279 127.875 279s43.594-19.518 43.594-43.594c0-5.062-.448-8.87-2.118-13.54a2.642 2.642 0 0 0-4.976 1.778c1.467 4.103 1.81 7.308 1.81 11.762 0 21.158-17.152 38.31-38.31 38.31s-38.31-17.152-38.31-38.31 17.152-38.31 38.31-38.31c4.787 0 9.448.878 13.814 2.566a2.642 2.642 0 0 0 1.906-4.928"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    fillRule: "nonzero",
    d: "M167.711 196.139a2.906 2.906 0 0 1 0 4.11l-33.989 33.988 13.646 13.645a2.906 2.906 0 0 1 .13 3.971l-.13.14a2.906 2.906 0 0 1-4.11 0l-13.647-13.646-13.644 13.646a2.906 2.906 0 0 1-4.11-4.11l13.644-13.646-14.212-14.213a2.906 2.906 0 0 1-.131-3.97l.13-.14a2.906 2.906 0 0 1 4.11 0l14.215 14.213L163.6 196.14a2.906 2.906 0 0 1 4.11 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E7780",
    fillRule: "nonzero",
    d: "M127.875 58.125c24.076 0 43.594 19.518 43.594 43.594s-19.518 43.594-43.594 43.594-43.594-19.518-43.594-43.594 19.518-43.594 43.594-43.594m0 5.813c-20.866 0-37.781 16.915-37.781 37.78 0 20.867 16.915 37.782 37.781 37.782s37.781-16.915 37.781-37.781-16.915-37.781-37.781-37.781"
  })))));
};
export default SvgNotAvailableUser;